import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { api } from '../api';
import './Login.css';

export default function ForgotPassword({ onBackToLogin }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle' | 'sending' | 'sent'
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStatus('sending');
    try {
      await api.forgotPassword(email);
      setStatus('sent');
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
      setStatus('idle');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Forgot Password</h1>
          <p>Enter your email and we'll send you a reset link</p>
        </div>

        {status === 'sent' ? (
          <div className="auth-form">
            <div
              className="auth-success"
              style={{
                background: '#ecfdf5',
                color: '#065f46',
                padding: 16,
                borderRadius: 8,
                marginBottom: 16,
              }}
            >
              If an account exists for <strong>{email}</strong>, a password reset
              link has been sent. Check your inbox (and spam folder). The link
              expires in 1 hour.
            </div>
            <button
              type="button"
              className="auth-button"
              onClick={onBackToLogin}
            >
              Back to Sign In
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <div className="input-wrapper">
                <Mail size={18} className="input-icon" />
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                />
              </div>
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button
              type="submit"
              className="auth-button"
              disabled={status === 'sending'}
            >
              {status === 'sending' ? 'Sending...' : 'Send reset link'}
            </button>

            <div style={{ textAlign: 'center', marginTop: 12 }}>
              <button
                type="button"
                onClick={onBackToLogin}
                className="auth-link"
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              >
                Back to Sign In
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
